/**
 * user_books 한 행이 가진 세 가지 상태를 화면 쪽에서 읽기 위한 도우미.
 *
 *   담아둠(want_to_read) → 아직 안 읽은 책. 궤도 밖에 있다.
 *   읽는 중              → 등록했지만 완료일이 없는 책
 *   완독(completedBy)    → 행성에 자리를 잡은 책
 *
 * 담아둔 책은 "읽은 책" 이 아니므로 권수·유사도·궤적·독자 수 어디에도
 * 섞이면 안 된다. 그 판정을 한 곳에 모아둔다.
 */

/** 이 사람이 담아두기만 한 책인가 */
export function isWish(book, uid) {
  return !!(uid && book?.wantToReadBy && book.wantToReadBy[uid]);
}

/** 담아둔 책을 걷어낸 목록 — 읽은 책 + 읽는 중 */
export function readBooks(books, uid) {
  return (books || []).filter((b) => !isWish(b, uid));
}

/** 담아둔 책만 */
export function wishBooks(books, uid) {
  return (books || []).filter((b) => isWish(b, uid));
}
